var React = require('react');

function IconProjectlist (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M152.6 307.2v-63.8c0-2.2 1.8-4 4-4h711.6c2.2 0 4 1.8 4 4v63.8c0 2.2-1.8 4-4 4H156.6c-2.2 0-4-1.8-4-4zm60-174.2v53.8c0 2.2 1.8 4 4 4h593.9c2.2 0 4-1.8 4-4V133c0-2.2-1.8-4-4-4H216.6c-2.2 0-4 1.8-4 4zM928 878.1c0 8.5-6.7 15.4-15.1 15.4h-801c-8.4 0-15.1-7-15.1-15.4V377.7c0-10.4 8.5-18.8 19-18.8H909c10.5 0 19 8.4 19 18.8v500.4z"}));
}

IconProjectlist.displayName = "IconProjectlist";

IconProjectlist.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconProjectlist;

IconProjectlist.default = IconProjectlist;
